export type Team = 0 | 1;

export const DROP_TYPES = ['attractor', 'deflector', 'speed', 'explosion', 'surge'] as const;
export type DropType = (typeof DROP_TYPES)[number];

export type MatchPhase = 'ready' | 'playing' | 'paused' | 'finished';
export type ZoneType = 'forge' | 'shield' | 'decay';

export interface Vec2 {
  x: number;
  y: number;
}

export interface Unit extends Vec2 {
  id: number;
  team: Team;
  vx: number;
  vy: number;
  health: number;
  weapon: boolean;
  shield: boolean;
  decayExposure: number;
  inForgeZone: boolean;
  inShieldZone: boolean;
  contactCooldownUntil: number;
}

export interface Core extends Vec2 {
  team: Team;
  health: number;
  maxHealth: number;
}

export interface Obstacle extends Vec2 {
  radius: number;
}

export interface ArenaZone extends Vec2 {
  type: ZoneType;
  radius: number;
}

export interface FieldEffect extends Vec2 {
  id: number;
  type: Exclude<DropType, 'surge'>;
  team: Team;
  createdAt: number;
  expiresAt: number;
  triggered: boolean;
}

export interface InventoryState {
  items: DropType[];
  overflow: { type: DropType; expiresAt: number } | null;
  expiredCount: number;
}

export interface DeliveryState {
  nextAt: number;
  upcoming: DropType[];
  bag: DropType[];
}

export interface MatchStats {
  spawned: [number, number];
  lost: [number, number];
  coreHits: [number, number];
  dropsUsed: Record<Team, Record<DropType, number>>;
}

export interface SimulationEvent {
  type: 'delivery' | 'drop' | 'explosion' | 'elimination' | 'combat-hit' | 'zone-charge' | 'shield-break' | 'decay' | 'core-hit' | 'finish';
  team?: Team;
  drop?: DropType;
  zone?: ZoneType;
  x?: number;
  y?: number;
  count?: number;
}
